import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import EventBus from '../../../../utils/event-bus';
import { EVENT_BUS } from '../../../../common/constants';
import { RunningTaskModel } from '../../../../models/running-task/running-task.model';
import { Action, Getter, Mutation, namespace } from 'vuex-class';
import { storeModules } from '../../../../store';
import { IUploadCommon } from '../../../../models/common/upload-file-model';
import { STATUS_FAILED, STATUS_INITIAL, STATUS_SAVING, STATUS_SUCCESS, STATUS_PROCESSING } from '../../../../common/upload-state';
import moduleConstant from '../../../../common/module-constant';
import defineTypesStore from '../../../../store/report/report-large-mailing/define-types.store';

const ReportAction = namespace(storeModules.ReportLargeMailing, Action);
const CommonGetter = namespace(storeModules.Common, Getter);
const CommonMutation = namespace(storeModules.Common, Mutation);
@Component({
    template: require('./template.html'),
})
export default class RunningTasksComponent extends Vue {
    data = [];
    arrDialogInfo = [];

    @CommonGetter uploadModels: IUploadCommon[];
    @CommonMutation removeFilesUploadControl: (payload) => void;

    /** send email  */
    @ReportAction(defineTypesStore.Set.POST_DATA_LARGEMAILING)
    largeMailingAction: (action?: string) => Promise<any>;

    get coUploadList() {
        let uploadList = [];
        this.uploadModels.forEach(element => {
            uploadList = uploadList.concat(element.UploadFiles);
        });
        uploadList.sort((a, b) => -a.StartTime.localeCompare(b.StartTime))
        return uploadList;
    }

    get coTaskList() {
        let list = [...this.data];
        list.reverse();
        return list;
    }

    getTaskStatus(type: string) {

        switch (type) {
            case "success":
                return this.$t('SUCCESSFULLY').toString();
            case "scheduled":
                return this.$t('SCHEDULED_SUCCESSFULLY').toString();    
            case "danger":
                return this.$t('ERROR').toString();
            default:
                return this.$t('PRINTORDERSTATUSPENDING').toString() + "...";
        }
    }

    getTaskIcon(type: string) {
        switch (type) {
            case "scheduled":
            case "success":
                return "ico_checkmark";
            case "info":
                return "el-icon-magic-stick";
            case "danger":
                return "ico_close";
            default:
                return "el-icon-more";
        }
    }

    handleCloseUploadFile(file) {
        this.removeFilesUploadControl({
            id: file.UploadId,
            fileId: file.Id,
        })
    }

    addMailProgress(requestData) {
        const self = this;

        if (!this.data.find(e => e.id == requestData.id)) {
            this.data.push(new RunningTaskModel({
                id: requestData.id,
                title: `${self.$t('SENDMESSAGE').toString()} "${requestData.toEmails}"`,
                percentage: 0,
                type: "info"
            }))

            const listLength = requestData.listLength > 0 ? requestData.listLength : 1;
            const progressTime = setInterval(() => {
                const taskId = requestData.id;
                let thatTask = this.data.find(e => e.id === taskId);
                if (thatTask) {
                    if (thatTask.percentage >= 90) {
                        clearInterval(progressTime);
                    } else {
                        thatTask.percentage += (Math.floor(Math.random() * 5) + 1) / listLength;
                    }
                }
            }, 100)
        }
    }

    addLargeMailingProgress(requestData) {
        if (!requestData || !requestData.id) {
            console.error("Invalid request data", requestData);
            return;
        }

        // BAC-1653: the backend now returns immediately after queuing the
        // mass mailing â€” `data.IsSuccess === true` means "accepted & queued",
        // NOT "delivered". Actual sending happens in a background poller on
        // the server and the terminal sent/failed state is delivered via the
        // MessageNotification SignalR pipeline, surfaced in the notification
        // bell (which may take several hours).
        //
        // We therefore do NOT create a running-task tile at all â€” a fake
        // progress bar is misleading when the request resolves in
        // milliseconds and the real work happens server-side. Instead we
        // show a simple corner popup:
        //   - On queued success: success toast "Mass mailing created successfully".
        //   - On structured error (HTTP 200, IsSuccess=false / Errors set):
        //     error toast with the real error message.
        //   - On transport-level error (.catch): generic error toast.
        this.largeMailingAction()
            .then((data: any) => {
                const hasErrors = data && data.Errors && Object.keys(data.Errors).length > 0;
                const isQueued = !!(data && data.IsSuccess === true) && !hasErrors;

                if (!isQueued) {
                    let errorMessage = this.$t('EMAIL_FAILED').toString();
                    if (hasErrors) {
                        const firstKey = Object.keys(data.Errors)[0];
                        const firstError = data.Errors[firstKey] && data.Errors[firstKey][0];
                        if (firstError && firstError.ErrorMessage) {
                            errorMessage = firstError.ErrorMessage;
                        }
                    }
                    this.$notify({
                        title: this.$t('ERROR').toString(),
                        message: errorMessage,
                        type: 'error'
                    });
                    return;
                }

                this.$notify({
                    title: this.$t('SUCCESSFULLY').toString(),
                    message: this.$t('LARGE_MAILING_CREATED_SUCCESSFULLY').toString(),
                    type: 'success'
                });
            })
            .catch(ex => {
                console.error("Error during large mailing action", ex);
                this.$notify({
                    title: this.$t('ERROR').toString(),
                    message: this.$t('EMAIL_FAILED').toString(),
                    type: 'error'
                });
            });
    }


    addProgress(requestData) {
        const self = this;

        if (!this.data.find(e => e.id === requestData.id)) {
            this.data.push(new RunningTaskModel({
                id: requestData.id,
                title: `${self.$t('PUBLISH').toString()} ${requestData.socialTypeName}`,
                percentage: 0,
                type: "info"
            }))

            const progressTime = setInterval(() => {
                const taskId = requestData.id;
                let thatTask = this.data.find(e => e.id === taskId);
                if (thatTask) {
                    if (thatTask.percentage >= 90) {
                        clearInterval(progressTime);
                    } else {
                        thatTask.percentage += Math.random();
                    }
                }
            }, 100)
        }
    }

    endProgress(id) {
        this.data = [...this.data].map(e => {
            let sessionId = e.id.split("--")[0];
            if (e.id === id || sessionId === id) {
                e.type = "success";
                e.percentage = 100;
            }
            return e;
        })
    }

    endSchedulingProcess(id) {
        this.data = [...this.data].map(e => {
            let sessionId = e.id.split("--")[0];
            if (e.id === id || sessionId === id) {
                e.type = "scheduled";
                e.percentage = 100;
            }
            return e;
        })
    }

    failProgress(id) {
        this.data = [...this.data].map(e => {
            let sessionId = e.id.split("--")[0];
            if (e.id === id || sessionId === id) {
                e.type = "danger";
                e.percentage = 100;
            }
            return e;
        })
    }

    handleCloseTask(id) {
        this.data = [...this.data].filter(e => e.id !== id);
        this.$forceUpdate();
    }

    getModuleName(module) {
        switch (module) {
            case moduleConstant.Object:
                return 'Property'
            case moduleConstant.Project:
                return 'Project'
            case moduleConstant.Person:
                return 'Person'
            case moduleConstant.Company:
                return 'Company'
            case moduleConstant.Configs:
                return 'Configuration'
            default:
                return null
        }
    }

    getUploadStatus(file) {
        switch (file.Status) {
            case STATUS_INITIAL:
                return `Uploading...`
            case STATUS_PROCESSING:
                return this.$t('PROCESSING_VIDEO').toString();
            case STATUS_SAVING:
                return `Saving file...`
            case STATUS_SUCCESS:
                return this.$t('SUCCESSFULLY').toString();
            case STATUS_FAILED:
                return this.$t('ERROR').toString();
            default:
                break;
        }
        return ``
    }

    getUploadColor(file) {
        switch (file.Status) {
            case STATUS_INITIAL:
                return '#409eff'
            case STATUS_PROCESSING:
                return "#9b59b6"
            case STATUS_SAVING:
                return "#e6a23c"
            case STATUS_SUCCESS:
                return "#67c23a"
            case STATUS_FAILED:
                return "#f56c6c"
            default:
                break;
        }
        return null
    }

    transformIconUrl(url) {
        return `${url}?_t=${new Date().getTime()}`
    }

    getFileLocation(file) {
        const result = `${this.getModuleName(file.Module)}: ${file.Reference}`;
        return result;
    }

    handleClick() {
        if (this.$refs.button) {
            //@ts-ignore
            this.$refs.button.$el.click();
        }
    }

    handleCancelSingleFile(file) {
        EventBus.$emit(EVENT_BUS.UPLOAD_CONTROL.CANCEL_SINGLE_FILE, file);
    }

    handleRetry(file) {
        EventBus.$emit(EVENT_BUS.UPLOAD_CONTROL.RETRY_UPLOAD_SINGLE_FILE, file);
    }

    handleMoveToFile(file) {
        this.$router.push({ path: file.UploadId, query: { uploadType: file.Type }})
    }

    get totalPercent() {
        let pct = 0;
        let percentList = [...this.data].filter(e => e.percentage < 100).map(t => {
            pct += t.percentage;
            return t.percentage;
        });
        if (percentList.length === 0) return 100;

        return pct * 100 / (percentList.length * 100)
    }

    get uploadProgress() {
        let pct = 0;
        let percentList = this.coUploadList.filter(e => e.Progress < 100).map(t => {
            pct += t.Progress;
            return t.Progress;
        });
        if (percentList.length === 0) return 100;

        return pct * 100 / (percentList.length * 100)
    }

    get checkUploadStatus() {
        const upload = this.coUploadList.find(x => x.Status === STATUS_INITIAL || x.Status === STATUS_SAVING || x.Status === STATUS_PROCESSING);
        return upload ? true : false;
    }

    get isLoading() {
        return (this.totalPercent != 100 || this.uploadProgress != 100) || this.checkUploadStatus
    }

    get dynamicBackgound() {
        let fakeTotal = !this.isLoading  ? 100 : 50;
        let colorCode = fakeTotal === 100 ? "#4db925" : "#E6A23C";
        return `background-image: linear-gradient(0deg,${colorCode} ${fakeTotal}%,#ececec ${100 - fakeTotal}%), linear-gradient(0deg,${colorCode} 50%,#ececec 50%)`;
    }

    showDialogById(id){
        const dialogInfo = this.arrDialogInfo.find(e => e.id === id);
        
        if (dialogInfo) {
            this.$confirm(dialogInfo.message, dialogInfo.title, {
                confirmButtonText: this.$t('DONE_SCHEDULED_POSTS').toString(),
                showCancelButton: false,
                type: 'success',
                customClass: 'social-sharing-result'
            }).then(() => { })
        }
    }

    handleAddDialog(data){
        this.arrDialogInfo.push(data);
    }


    mounted() {
        EventBus.$on(EVENT_BUS.RUNNING_TASK.PUBLISH_FILE_START, (requestData) => {
            this.addProgress(requestData);
        });

        EventBus.$on(EVENT_BUS.RUNNING_TASK.SEND_MAIL_START, (requestData) => {
            this.addMailProgress(requestData);
        });

        EventBus.$on(EVENT_BUS.RUNNING_TASK.SEND_LARGE_MAILING_START, (requestData) => {
            this.addLargeMailingProgress(requestData);
        });

        EventBus.$on(EVENT_BUS.RUNNING_TASK.COMPLETE, (id) => {
            this.endProgress(id);
        });

        EventBus.$on(EVENT_BUS.RUNNING_TASK.SCHEDULED, (id) => {
            this.endSchedulingProcess(id);
            this.showDialogById(id);
        });

        EventBus.$on(EVENT_BUS.RUNNING_TASK.FAIL, (id) => {
            this.failProgress(id);
        });
        EventBus.$on(EVENT_BUS.RUNNING_TASK.OPEN, this.handleClick);
        EventBus.$on(EVENT_BUS.DIALOG.ADD, this.handleAddDialog);

    }

    beforeDestroy() {
        // EventBus.$off(EVENT_BUS.RUNNING_TASK.PUBLISH_FILE_START);
        // EventBus.$off(EVENT_BUS.RUNNING_TASK.SEND_MAIL_START);
        // EventBus.$off(EVENT_BUS.RUNNING_TASK.COMPLETE);
        // EventBus.$off(EVENT_BUS.RUNNING_TASK.FAIL);
    }

    @Watch('isLoading')
    onIsLoadingChange(val) {
        if (val === false) {
            setTimeout(() => {
                const dropdown = this.$refs.dropdown as any;
                dropdown.hide();
            }, 3000);
        }
    }
}
